import { Component, OnInit } from '@angular/core';
import { fromStore } from '../../../core/store';
import { Store } from '@ngrx/store';
import { InvitesService } from '../../../core/services/invites.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Invite } from '../../../core/models/entities/invite';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiError } from '../../../core/models/common/api-error';
import { AuthService } from '../../../core/services/auth.service';
import { authActions } from '../../../core/store/auth';
import { ToastService } from '../../../core/services/toast.service';

@Component({
  selector: 'app-accept-invite-page',
  template: `
    <app-auth-template title="Rejoindre l'équipe">
      @if (userMustRegister$ | async) {
        <div>
          <div class="mb-6"
            >Vous avez été invité à rejoindre l'équipe
            <span class="font-bold">{{ invite.vendor.name }}</span
              >, veuillez remplir les champs ci-dessous pour créer votre
              compte.</div
              >
              <app-register-form
                [first_name]="invite.first_name"
                [last_name]="invite.last_name"
                [email]="invite.email"
                [inviteId]="invite.id"
                buttonText="Rejoindre l'équipe"
                (afterRegister)="acceptInvite()"
              ></app-register-form>
            </div>
          }
    
          @if (userMustLogin$ | async) {
            <app-login-form
              [email]="invite.email"
            ></app-login-form>
          }
    
          @if (canAcceptInvite$ | async) {
            <div>
              <div class="text-center"
                >Si vous souhaitez rejoindre {{ invite.vendor?.name }}, vous pouvez le
                faire en cliquant sur le bouton ci-dessous.</div
                >
                <div class="mt-8 flex justify-center">
                  <app-button id="accept-invite-button" (click)="acceptInvite()"
                    >Rejoindre</app-button
                    >
                  </div>
                </div>
              }
    
              @if (userEmailDoesNotMatch$ | async) {
                <div>
                  <div class="text-center"
                    >Votre adresse e-mail ne correspond pas à celle de l'invitation.
                    Veuillez vous déconnecter, puis vous inscrire avec l'adresse e-mail
                    sur laquelle le lien d'invitation a été transmis.
                  </div>
                  <div class="mt-8 flex justify-center">
                    <app-button id="invite-logout-button" (click)="logout()"
                      >Se déconnecter</app-button
                      >
                    </div>
                  </div>
                }
    
                @if (loading) {
                  <div class="relative pt-48">
                    <app-loader [centered]="true"></app-loader>
                  </div>
                }
    
                @if (!loading && !invite) {
                  <div class="relative pt-48">
                    <app-empty-state
                      [showAddButton]="false"
                      icon="comment-alt-slash"
                      message="Invitation introuvable ou déjà utilisée"
                    ></app-empty-state>
                  </div>
                }
              </app-auth-template>
    `,
  standalone: false,
})
export class AcceptInvitePageComponent implements OnInit {
  user$ = this.store.select(fromStore.selectAuthUser);
  userEmailDoesNotMatch$: Observable<boolean>;
  userMustLogin$: Observable<boolean>;
  userMustRegister$: Observable<boolean>;
  canAcceptInvite$: Observable<boolean>;
  loading = false;
  invite: Invite;

  constructor(
    private store: Store,
    private invitesService: InvitesService,
    private route: ActivatedRoute,
    private toastService: ToastService,
    private router: Router,
    private authService: AuthService,
  ) {}

  async ngOnInit() {
    this.loading = true;
    try {
      this.invite = (
        await this.invitesService.verify({
          email: this.route.snapshot.params['email'],
          token: this.route.snapshot.params['token'],
        })
      ).data;
      this.canAcceptInvite$ = this.user$.pipe(
        map((user) => user?.email === this.invite.email),
      );
      this.userEmailDoesNotMatch$ = this.user$.pipe(
        map((user) => user && user.email !== this.invite.email),
      );
      this.userMustLogin$ = this.user$.pipe(
        map((user) => !user && this.invite.user_exists),
      );
      this.userMustRegister$ = this.user$.pipe(
        map((user) => !user && !this.invite.user_exists),
      );
    } catch (exception) {}
    this.loading = false;
  }

  async acceptInvite() {
    try {
      const user = await this.invitesService.accept({
        email: this.route.snapshot.params['email'],
        token: this.route.snapshot.params['token'],
      });
      this.store.dispatch(authActions.findCurrentUserSuccess({ user }));
      this.toastService.success(
        `Félicitations. Vous avez maintenant rejoint ${this.invite.vendor.name} !`,
      );
      await this.router.navigate(['/reservations']);
    } catch (exception) {
      this.toastService.error((exception as ApiError).message);
    }
  }

  async logout() {
    try {
      await this.authService.logout(false);
    } catch (exception) {
      this.toastService.error((exception as ApiError).message);
    }
  }
}
